import { ColorGlobal, ColorNeutral, ColorSafety, ColorShade, ColorSignal, SignalShade } from '../../../../prop-types/color.js';
function getColorGlobalValues() {
    return Object.values(ColorGlobal)
        .reduce((result, color) => ({
        ...result,
        [color]: Object.values(ColorShade).map(shade => ({
            color: `${color}-${shade}`,
            shade,
        })),
    }), {});
}
function getColorNeutralValues() {
    return Object.values(ColorNeutral)
        .reduce((result, color) => ({
        ...result,
        [color]: [{
                color: color,
            }],
    }), {});
}
function getColorSignalValues() {
    return Object.values(ColorSignal)
        .reduce((result, color) => ({
        ...result,
        [color]: Object.values(SignalShade).map(shade => ({
            color: `signal-${color}-${shade}`,
            shade,
        })),
    }), {});
}
function getColorSafetyValues() {
    return Object.values(ColorSafety)
        .reduce((result, color) => ({
        ...result,
        [color]: [{
                color: `safety-${color}`,
            }],
    }), {});
}
export { getColorGlobalValues, getColorNeutralValues, getColorSignalValues, getColorSafetyValues, };
//# sourceMappingURL=color-palette-utils.js.map